import { connect } from 'react-redux';
import IssueTab from 'components/data/Issue';
import {
  getDataList,
  setSortBy,
  getCategories,
  getComposites,
  getRegions,
  getSubcategories,
  getCountrySectors,
  getIndicators,
  getActiveYears
} from 'redux-modules/data';
import { getCountries } from 'redux-modules/country-profiles';
import { filterData, getDownloadGeneralLink } from 'selectors/data';


const mapStateToProps = (state) => ({
  filteredData: filterData(state),
  loading: state.countryProfile.countriesLoading || state.data.countrySectorsLoading || state.data.activeYearsLoading,
  options: state.data.options,
  filters: state.data.filters,
  sort: state.data.sort,
  mapCountries: state.countryProfile.mapCountries,
  downloadLink: getDownloadGeneralLink(state),
  activeYears: state.data.activeYears
});

const mapDispatchToProps = (dispatch) => ({
  getDataList: () => dispatch(getDataList()),
  getActiveYears: () => dispatch(getActiveYears()),
  setSortBy: (type, direction) => dispatch(setSortBy(type, direction)),
  getCountries: (filters) => dispatch(getCountries(filters)),
  getFilters: () => {
    dispatch(getRegions());
    dispatch(getCategories());
    dispatch(getComposites());
  },
  getCountrySectors: (filters) => dispatch(getCountrySectors(filters)),
  getSubcategories: (categoryId) => dispatch(getSubcategories(categoryId)),
  getIndicators: (subcategoryId) => dispatch(getIndicators(subcategoryId))
});

export default connect(mapStateToProps, mapDispatchToProps)(IssueTab);



// WEBPACK FOOTER //
// ./app/containers/data/Issue.js